export default "__VITE_ASSET__01a92611__"